import script from "./CreateUpdateStorePickupRule.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUpdateStorePickupRule.vue?vue&type=script&setup=true&lang=ts"

import "./CreateUpdateStorePickupRule.vue?vue&type=style&index=0&id=796d1bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796d1bd8"]])

export default __exports__